import React from 'react'

import config from '../../config/config.json';

import './MyProfile.scss';

function MyProfile(props) {
  return (
    <div className="my-profile-container">
      <table className="my-profile-table">
        <thead>
          <tr>
            <th className="my-profile-header">
              <div className="my-profile-icon-container">
                <div className="my-profile-icon">
                  <img
                    id="myProfileUserImage"
                    alt="User Image Not Found"
                    aria-hidden="true"
                    src={config.bootstrapUrl_user}
                  />
                </div>
                <span>My Profile</span>
              </div>
              </th>
            <th className="my-profile-header"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="my-profile-title-column">Name</td>
            <td className="my-profile-detail-column">{props.subscriberDetails.name}</td>
          </tr>
          <tr>
            <td className="my-profile-title-column">Email</td>
            <td className="my-profile-detail-column">{props.subscriberDetails.email}</td>
          </tr>
          <tr>
            <td className="my-profile-title-column">Subscriber ID</td>
            <td className="my-profile-detail-column">{props.subscriberDetails.subscriberID}</td>
          </tr>
          <tr>
            <td className="my-profile-title-column">Company</td>
            <td className="my-profile-detail-column">{props.subscriberDetails.company}</td>
          </tr>
          <tr>
            <td className="my-profile-title-column">Account Manager</td>
            <td className="my-profile-detail-column">{props.subscriberDetails.accountManager}</td>
          </tr>
          <tr>
            <td className="my-profile-address-title-column">Address</td>
            <td className="my-profile-address-column">
              {props.subscriberDetails.address1}
              <br></br>
              {props.subscriberDetails.address2}
              <br></br>
              {props.subscriberDetails.city}
              <br></br>
              {props.subscriberDetails.county}
              <br></br>
              {props.subscriberDetails.postcode}
            </td>
          </tr>
          <tr>
            <td className="my-profile-title-column">Phone Number</td>
            <td className="my-profile-detail-column">{props.subscriberDetails.phoneNo}</td>
          </tr>
          <tr>
            <td className="my-profile-title-column">Direct Phone Number</td>
            <td className="my-profile-detail-column">{props.subscriberDetails.directPhoneNo}</td>
          </tr>
          <tr>
            <td className="my-profile-title-column">Fax Number</td>
            <td className="my-profile-detail-column">{props.subscriberDetails.faxNo}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default MyProfile
